import { render, staticRenderFns } from "./EmployeeFolderEdit.vue?vue&type=template&id=53b4a82d&scoped=true&"
import script from "./EmployeeFolderEdit.vue?vue&type=script&lang=js&"
export * from "./EmployeeFolderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b4a82d",
  null
  
)

export default component.exports